import type { RouteWithTitle } from '@pbk-web/types';
import { lazy } from 'react';

// Always registered; the route component gates on the `playbook-labs` PostHog flag and
// renders the standard not-found page when it's off (see LabsRouteSwitch). Reachable both
// globally and scoped to the active client, so it stays "on" the client you're viewing.
const labsRoutes: RouteWithTitle[] = [
  {
    id: 'labs',
    path: ['/labs', '/clients/:clientId/labs'],
    translationKey: 'page.labs',
    component: lazy(() => import('../pages/labs/LabsRouteSwitch')),
  },
];

export default labsRoutes;
